var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwedish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "182px",
    viewBox: "0 0 182 182",
    width: "182px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sweden",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    d: "M90,180 C139.70563,180 180,139.70563 180,90 C180,40.2943701 139.70563,0 90,0 C40.2943701,0 0,40.2943701 0,90 C0,139.70563 40.2943701,180 90,180 Z M90,180",
    fill: "#4086CD",
    id: "Oval-1-copy-4",
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9999996,5.12117078 C48.8214053,9.07223656 38.6564375,15.1690819 30,22.916803 L30,157.083197 C38.6564376,164.830918 48.8214054,170.927763 59.9999996,174.878829 L60,5.12116698 Z M59.9999996,5.12117078",
    fill: "#E5B731",
    id: "Oval-1-copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.755624,105 C179.574018,100.121873 180,95.1106832 180,90 C180,84.8893168 179.574018,79.8781271 178.755624,75 L1.24437643,75 C0.425981881,79.8781271 0,84.8893168 0,90 C0,95.1106832 0.425981881,100.121873 1.24437643,105 L178.755624,105 Z M178.755624,105",
    fill: "#E5B731",
    id: "Oval-1-copy-6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedish);
export default __webpack_public_path__ + "static/media/swedish.7d255f01adeb1998f582b4546e071a3c.svg";
export { ForwardRef as ReactComponent };